var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-sm-12 col-xs-12 col-md-12 notification_tabs" },
      [
        [
          _c("div", { staticClass: "tabs-left" }, [
            _c(
              "ul",
              { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
              [
                _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.activeAlertPrefTab == "RegTracker" },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            _vm.activeAlertPrefTab = "RegTracker"
                          },
                        },
                      },
                      [_vm._v("Registration Tracker")]
                    ),
                  ]
                ),
                _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.activeAlertPrefTab == "RegWatch" },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            _vm.activeAlertPrefTab = "RegWatch"
                          },
                        },
                      },
                      [_vm._v("Regulatory Watch")]
                    ),
                  ]
                ),
                _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.activeAlertPrefTab == "SmartBuilder" },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            _vm.activeAlertPrefTab = "SmartBuilder"
                          },
                        },
                      },
                      [_vm._v("Smart Builder")]
                    ),
                  ]
                ),
                _vm.display_smart_exchange
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        class: {
                          active: _vm.activeAlertPrefTab == "SmartExchange",
                        },
                        attrs: { role: "presentation" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "nav-link",
                            attrs: { role: "tab", "data-toggle": "tab" },
                            on: {
                              click: function ($event) {
                                _vm.activeAlertPrefTab = "SmartExchange"
                              },
                            },
                          },
                          [_vm._v("Smart Exchange")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: {
                      active: _vm.activeAlertPrefTab == "GeneralNotifications",
                    },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            _vm.activeAlertPrefTab = "GeneralNotifications"
                          },
                        },
                      },
                      [_vm._v("General Notifications")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.activeAlertPrefTab == "RegTracker" &&
                  _vm.displayRegTracker,
                expression:
                  "activeAlertPrefTab == 'RegTracker' && displayRegTracker",
              },
            ],
          },
          [
            _c("div", { staticClass: "mb-15 mt-15 alert-content" }, [
              _vm._v(
                " Indicate the type of notification you would like to receive. Notifications can be sent via email and/or displayed within the application. In-app notifications can be viewed on the Notifications page. "
              ),
            ]),
            _c("div", { staticClass: "container1" }, [
              _c("div", { staticClass: "section" }, [
                _c("div", { staticClass: "scrollable-content content" }, [
                  _c("div", { staticClass: "row_wrapper row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-6 col-sm-6 col-xs-12 header_label_text",
                      },
                      [_vm._v("Type")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-3 col-sm-3 hide_xs in_app_label header_label_text",
                      },
                      [_vm._v(" In-app Notification ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-3 email_tab hide_xs" },
                      [
                        _c("span", { staticClass: "ml-15 header_label_text" }, [
                          _vm._v("Email"),
                        ]),
                        _c(
                          "el-popover",
                          {
                            staticClass: "main_popover",
                            attrs: {
                              placement: "bottom-end",
                              trigger: "click",
                            },
                            on: {
                              show: function ($event) {
                                _vm.infoActive = true
                              },
                              hide: function ($event) {
                                _vm.infoActive = false
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("div", { staticClass: "mb-10" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "tooltip_sub_content_heading",
                                  },
                                  [_vm._v("Never:")]
                                ),
                                _vm._v(" No emails will be sent "),
                              ]),
                              _c("div", { staticClass: "mb-10" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "tooltip_sub_content_heading",
                                  },
                                  [_vm._v("Every Alert:")]
                                ),
                                _vm._v(
                                  " Emails will be sent immediately and for every triggered notification "
                                ),
                              ]),
                              _c("div", { staticClass: "mb-10" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "tooltip_sub_content_heading",
                                  },
                                  [_vm._v("Daily summary:")]
                                ),
                                _vm._v(
                                  " A daily summary of the triggered notification type will be sent "
                                ),
                              ]),
                              _c("div", { staticClass: "mb-10" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "tooltip_sub_content_heading",
                                  },
                                  [_vm._v("Weekly summary:")]
                                ),
                                _vm._v(
                                  " A weekly summary of the triggered notification type will be sent "
                                ),
                              ]),
                            ]),
                            !_vm.infoActive
                              ? _c("img", {
                                  staticClass: "info-img",
                                  attrs: {
                                    slot: "reference",
                                    src: "/static/images/icons/info_icon.svg",
                                    alt: "infoa-icon",
                                  },
                                  slot: "reference",
                                })
                              : _vm._e(),
                            _vm.infoActive
                              ? _c("img", {
                                  staticClass: "info-img",
                                  attrs: {
                                    slot: "reference",
                                    src: "/static/images/icons/info_icon_active.svg",
                                    alt: "infoactive-icon",
                                  },
                                  slot: "reference",
                                })
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row_wrapper row" }, [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-3 col-sm-3 col-xs-6 toggle_switch",
                      },
                      [
                        _c("small", { staticClass: "display_xs" }, [
                          _vm._v("In-app Notifications"),
                        ]),
                        _c("label", { staticClass: "switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.selectedPreferences[
                                    "alertRegistrationNew"
                                  ],
                                expression:
                                  "selectedPreferences['alertRegistrationNew']",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selectedPreferences["alertRegistrationNew"]
                              )
                                ? _vm._i(
                                    _vm.selectedPreferences[
                                      "alertRegistrationNew"
                                    ],
                                    null
                                  ) > -1
                                : _vm.selectedPreferences[
                                    "alertRegistrationNew"
                                  ],
                            },
                            on: {
                              change: function ($event) {
                                var $$a =
                                    _vm.selectedPreferences[
                                      "alertRegistrationNew"
                                    ],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationNew",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationNew",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedPreferences,
                                    "alertRegistrationNew",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _c("span", { staticClass: "slider round" }),
                        ]),
                        _vm.selectedPreferences["alertRegistrationNew"]
                          ? _c("span", { staticClass: "switch_label" }, [
                              _vm._v("On"),
                            ])
                          : _c(
                              "span",
                              { staticClass: "switch_label switch_off" },
                              [_vm._v("Off")]
                            ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5" },
                      [
                        _c("small", { staticClass: "display_xs ml-20" }, [
                          _vm._v("Email"),
                        ]),
                        _vm.loaderStatus == false
                          ? _c(
                              "multiselect",
                              {
                                staticClass: "multiselect-single-dropdown",
                                attrs: {
                                  showLabels: false,
                                  "close-on-select": true,
                                  "allow-empty": false,
                                  searchable: false,
                                  "open-direction": "bottom",
                                  options: _vm.frequency_options.map(
                                    (frequency) => frequency.value
                                  ),
                                  "custom-label": (option) =>
                                    _vm.frequency_options.find(
                                      (x) => x.value === option
                                    ).label,
                                  placeholder: "Select",
                                },
                                model: {
                                  value:
                                    _vm.email_frequency[
                                      "email_registration_new"
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.email_frequency,
                                      "email_registration_new",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "email_frequency['email_registration_new']",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult",
                                  },
                                  [_vm._v("No matching data")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row_wrapper row" }, [
                    _vm._m(1),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-3 col-sm-3 col-xs-6 toggle_switch",
                      },
                      [
                        _c("small", { staticClass: "display_xs" }, [
                          _vm._v("In-app Notifications"),
                        ]),
                        _c("label", { staticClass: "switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.selectedPreferences[
                                    "alertRegistrationModified"
                                  ],
                                expression:
                                  "selectedPreferences['alertRegistrationModified']",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selectedPreferences[
                                  "alertRegistrationModified"
                                ]
                              )
                                ? _vm._i(
                                    _vm.selectedPreferences[
                                      "alertRegistrationModified"
                                    ],
                                    null
                                  ) > -1
                                : _vm.selectedPreferences[
                                    "alertRegistrationModified"
                                  ],
                            },
                            on: {
                              change: function ($event) {
                                var $$a =
                                    _vm.selectedPreferences[
                                      "alertRegistrationModified"
                                    ],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationModified",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationModified",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedPreferences,
                                    "alertRegistrationModified",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _c("span", { staticClass: "slider round" }),
                        ]),
                        _vm.selectedPreferences["alertRegistrationModified"]
                          ? _c("span", { staticClass: "switch_label" }, [
                              _vm._v("On"),
                            ])
                          : _c(
                              "span",
                              { staticClass: "switch_label switch_off" },
                              [_vm._v("Off")]
                            ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5" },
                      [
                        _c("small", { staticClass: "display_xs ml-20" }, [
                          _vm._v("Email"),
                        ]),
                        _c(
                          "multiselect",
                          {
                            staticClass: "multiselect-single-dropdown",
                            attrs: {
                              showLabels: false,
                              "close-on-select": true,
                              "allow-empty": false,
                              "open-direction": "bottom",
                              searchable: false,
                              options: _vm.frequency_options.map(
                                (frequency) => frequency.value
                              ),
                              "custom-label": (option) =>
                                _vm.frequency_options.find(
                                  (x) => x.value === option
                                ).label,
                              placeholder: "Select",
                            },
                            model: {
                              value:
                                _vm.email_frequency[
                                  "email_registration_modified"
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.email_frequency,
                                  "email_registration_modified",
                                  $$v
                                )
                              },
                              expression:
                                "email_frequency['email_registration_modified']",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [_vm._v("No matching data")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row_wrapper row" }, [
                    _vm._m(2),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-3 col-sm-3 col-xs-6 toggle_switch",
                      },
                      [
                        _c("small", { staticClass: "display_xs" }, [
                          _vm._v("In-app Notifications"),
                        ]),
                        _c("label", { staticClass: "switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.selectedPreferences[
                                    "alertRegistrationDeleted"
                                  ],
                                expression:
                                  "selectedPreferences['alertRegistrationDeleted']",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selectedPreferences[
                                  "alertRegistrationDeleted"
                                ]
                              )
                                ? _vm._i(
                                    _vm.selectedPreferences[
                                      "alertRegistrationDeleted"
                                    ],
                                    null
                                  ) > -1
                                : _vm.selectedPreferences[
                                    "alertRegistrationDeleted"
                                  ],
                            },
                            on: {
                              change: function ($event) {
                                var $$a =
                                    _vm.selectedPreferences[
                                      "alertRegistrationDeleted"
                                    ],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationDeleted",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationDeleted",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedPreferences,
                                    "alertRegistrationDeleted",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _c("span", { staticClass: "slider round" }),
                        ]),
                        _vm.selectedPreferences["alertRegistrationDeleted"]
                          ? _c("span", { staticClass: "switch_label" }, [
                              _vm._v("On"),
                            ])
                          : _c(
                              "span",
                              { staticClass: "switch_label switch_off" },
                              [_vm._v("Off")]
                            ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5" },
                      [
                        _c("small", { staticClass: "display_xs ml-20" }, [
                          _vm._v("Email"),
                        ]),
                        _c(
                          "multiselect",
                          {
                            staticClass: "multiselect-single-dropdown",
                            attrs: {
                              showLabels: false,
                              "close-on-select": true,
                              "allow-empty": false,
                              "open-direction": "bottom",
                              searchable: false,
                              options: _vm.frequency_options.map(
                                (frequency) => frequency.value
                              ),
                              "custom-label": (option) =>
                                _vm.frequency_options.find(
                                  (x) => x.value === option
                                ).label,
                              placeholder: "Select",
                            },
                            model: {
                              value:
                                _vm.email_frequency[
                                  "email_registration_deleted"
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.email_frequency,
                                  "email_registration_deleted",
                                  $$v
                                )
                              },
                              expression:
                                "email_frequency['email_registration_deleted']",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [_vm._v("No matching data")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row_wrapper row" }, [
                    _vm._m(3),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-3 col-sm-3 col-xs-6 toggle_switch",
                      },
                      [
                        _c("small", { staticClass: "display_xs" }, [
                          _vm._v("In-app Notifications"),
                        ]),
                        _c("label", { staticClass: "switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.selectedPreferences[
                                    "alertRegistrationStatusChange"
                                  ],
                                expression:
                                  "selectedPreferences['alertRegistrationStatusChange']",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selectedPreferences[
                                  "alertRegistrationStatusChange"
                                ]
                              )
                                ? _vm._i(
                                    _vm.selectedPreferences[
                                      "alertRegistrationStatusChange"
                                    ],
                                    null
                                  ) > -1
                                : _vm.selectedPreferences[
                                    "alertRegistrationStatusChange"
                                  ],
                            },
                            on: {
                              change: function ($event) {
                                var $$a =
                                    _vm.selectedPreferences[
                                      "alertRegistrationStatusChange"
                                    ],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationStatusChange",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationStatusChange",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedPreferences,
                                    "alertRegistrationStatusChange",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _c("span", { staticClass: "slider round" }),
                        ]),
                        _vm.selectedPreferences["alertRegistrationStatusChange"]
                          ? _c("span", { staticClass: "switch_label" }, [
                              _vm._v("On"),
                            ])
                          : _c(
                              "span",
                              { staticClass: "switch_label switch_off" },
                              [_vm._v("Off")]
                            ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5" },
                      [
                        _c("small", { staticClass: "display_xs ml-20" }, [
                          _vm._v("Email"),
                        ]),
                        _c(
                          "multiselect",
                          {
                            staticClass: "multiselect-single-dropdown",
                            attrs: {
                              showLabels: false,
                              "close-on-select": true,
                              "allow-empty": false,
                              searchable: false,
                              options: _vm.frequency_options.map(
                                (frequency) => frequency.value
                              ),
                              "custom-label": (option) =>
                                _vm.frequency_options.find(
                                  (x) => x.value === option
                                ).label,
                              placeholder: "Select",
                            },
                            model: {
                              value:
                                _vm.email_frequency[
                                  "email_registration_status_change"
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.email_frequency,
                                  "email_registration_status_change",
                                  $$v
                                )
                              },
                              expression:
                                "email_frequency['email_registration_status_change']",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [_vm._v("No matching data")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row_wrapper pb-15 row" }, [
                    _vm._m(4),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-3 col-sm-3 col-xs-6 toggle_switch",
                      },
                      [
                        _c("small", { staticClass: "display_xs" }, [
                          _vm._v("In-app Notifications"),
                        ]),
                        _c("label", { staticClass: "switch" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.selectedPreferences[
                                    "alertRegistrationExpireSoon"
                                  ],
                                expression:
                                  "selectedPreferences['alertRegistrationExpireSoon']",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.selectedPreferences[
                                  "alertRegistrationExpireSoon"
                                ]
                              )
                                ? _vm._i(
                                    _vm.selectedPreferences[
                                      "alertRegistrationExpireSoon"
                                    ],
                                    null
                                  ) > -1
                                : _vm.selectedPreferences[
                                    "alertRegistrationExpireSoon"
                                  ],
                            },
                            on: {
                              change: function ($event) {
                                var $$a =
                                    _vm.selectedPreferences[
                                      "alertRegistrationExpireSoon"
                                    ],
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationExpireSoon",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.selectedPreferences,
                                        "alertRegistrationExpireSoon",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.selectedPreferences,
                                    "alertRegistrationExpireSoon",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _c("span", { staticClass: "slider round" }),
                        ]),
                        _vm.selectedPreferences["alertRegistrationExpireSoon"]
                          ? _c("span", { staticClass: "switch_label" }, [
                              _vm._v("On"),
                            ])
                          : _c(
                              "span",
                              { staticClass: "switch_label switch_off" },
                              [_vm._v("Off")]
                            ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-sm-3 col-xs-6 xs-mr-tp-5" },
                      [
                        _c("small", { staticClass: "display_xs ml-20" }, [
                          _vm._v("Email"),
                        ]),
                        _c("multiselect", {
                          staticClass: "multiselect-single-dropdown",
                          attrs: {
                            showLabels: false,
                            "close-on-select": true,
                            "allow-empty": false,
                            searchable: false,
                            options: _vm.frequency_options.map(
                              (frequency) => frequency.value
                            ),
                            "custom-label": (option) =>
                              _vm.frequency_options.find(
                                (x) => x.value === option
                              ).label,
                            placeholder: "Select",
                          },
                          model: {
                            value:
                              _vm.email_frequency[
                                "email_registration_expire_soon"
                              ],
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.email_frequency,
                                "email_registration_expire_soon",
                                $$v
                              )
                            },
                            expression:
                              "email_frequency['email_registration_expire_soon']",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm.account_type_id === 2 &&
                ((_vm.selectedPreferences["alertRegistrationExpireSoon"] !==
                  "" &&
                  !_vm.selectedPreferences["alertRegistrationExpireSoon"]) ||
                  (_vm.email_frequency["email_registration_expire_soon"] !==
                    "" &&
                    _vm.email_frequency["email_registration_expire_soon"] ===
                      "never"))
                  ? _c("div", { staticClass: "row indicator-block mr-5" }, [
                      _vm._m(5),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _c("notification-no-service", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.activeAlertPrefTab == "RegTracker" &&
                _vm.no_display_regtracker,
              expression:
                "activeAlertPrefTab == 'RegTracker' && no_display_regtracker",
            },
          ],
          on: {
            closepopup: function ($event) {
              return _vm.$emit("closepopup")
            },
          },
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.activeAlertPrefTab == "RegWatch" && _vm.displayRegUpdates,
                expression:
                  "activeAlertPrefTab == 'RegWatch' && displayRegUpdates",
              },
            ],
          },
          [
            _c("notification-regulatory-update", {
              ref: "regUpdate",
              attrs: {
                permissions: _vm.permissions,
                frequency_options: _vm.frequency_options,
                regulatory_email_notification_country_ids:
                  _vm.regulatory_email_notification_country_ids,
                email_frequency: _vm.email_frequency["email_regulatory_change"],
                account_id: _vm.account_id,
                sync_display: _vm.sync_display,
                default_country: _vm.default_country,
              },
              on: {
                "update:sync_display": function ($event) {
                  _vm.sync_display = $event
                },
                loaderStatus: _vm.getLoaderStatus,
              },
            }),
          ],
          1
        ),
        _c("notification-no-service", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.activeAlertPrefTab == "RegWatch" && _vm.no_display_regwatch,
              expression:
                "activeAlertPrefTab == 'RegWatch' && no_display_regwatch",
            },
          ],
          on: {
            closepopup: function ($event) {
              return _vm.$emit("closepopup")
            },
          },
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.activeAlertPrefTab == "SmartBuilder" &&
                  _vm.displaySmartBuilder,
                expression:
                  "activeAlertPrefTab == 'SmartBuilder' && displaySmartBuilder",
              },
            ],
          },
          [
            _c("notification-smart-builder", {
              attrs: {
                sb_email_preference: _vm.sb_email_preference,
                sb_in_app_preference: _vm.sb_in_app_preference,
              },
              on: {
                "update:sb_email_preference": function ($event) {
                  _vm.sb_email_preference = $event
                },
                "update:sb_in_app_preference": function ($event) {
                  _vm.sb_in_app_preference = $event
                },
              },
            }),
          ],
          1
        ),
        _c("notification-no-service", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.activeAlertPrefTab == "SmartBuilder" &&
                _vm.no_display_smart_builder,
              expression:
                "activeAlertPrefTab == 'SmartBuilder' && no_display_smart_builder",
            },
          ],
          on: {
            closepopup: function ($event) {
              return _vm.$emit("closepopup")
            },
          },
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeAlertPrefTab == "SmartExchange",
                expression: "activeAlertPrefTab == 'SmartExchange'",
              },
            ],
          },
          [
            _c("profile-notification-smart-exchange", {
              attrs: { sx_in_app_preference: _vm.sx_in_app_preference },
              on: {
                "update:sx_in_app_preference": function ($event) {
                  _vm.sx_in_app_preference = $event
                },
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.activeAlertPrefTab == "GeneralNotifications" &&
                  (_vm.displayProdClsfnNotifications ||
                    _vm.displayRegPathwayNotifications),
                expression:
                  "\n        activeAlertPrefTab == 'GeneralNotifications' &&\n        (displayProdClsfnNotifications || displayRegPathwayNotifications)\n      ",
              },
            ],
          },
          [
            _c("profile-notifications-general", {
              attrs: {
                regpathway_email_preference: _vm.regpathway_email_preference,
                regpathway_in_app_preference: _vm.regpathway_in_app_preference,
                prodclfn_email_preference: _vm.prodclfn_email_preference,
                prodclfn_in_app_preference: _vm.prodclfn_in_app_preference,
                displayProdClsfnNotifications:
                  _vm.displayProdClsfnNotifications,
                displayRegPathwayNotifications:
                  _vm.displayRegPathwayNotifications,
              },
              on: {
                "update:regpathway_email_preference": function ($event) {
                  _vm.regpathway_email_preference = $event
                },
                "update:regpathway_in_app_preference": function ($event) {
                  _vm.regpathway_in_app_preference = $event
                },
                "update:prodclfn_email_preference": function ($event) {
                  _vm.prodclfn_email_preference = $event
                },
                "update:prodclfn_in_app_preference": function ($event) {
                  _vm.prodclfn_in_app_preference = $event
                },
              },
            }),
          ],
          1
        ),
        _c("notification-no-service", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.activeAlertPrefTab == "GeneralNotifications" &&
                !(
                  _vm.displayProdClsfnNotifications ||
                  _vm.displayRegPathwayNotifications
                ),
              expression:
                "\n        activeAlertPrefTab == 'GeneralNotifications' &&\n        !(displayProdClsfnNotifications || displayRegPathwayNotifications)\n      ",
            },
          ],
          on: {
            closepopup: function ($event) {
              return _vm.$emit("closepopup")
            },
          },
        }),
        _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      ],
      2
    ),
    _vm.displayRegUpdates ||
    _vm.displayRegTracker ||
    _vm.displaySmartBuilder ||
    _vm.display_smart_exchange ||
    _vm.displayProdClsfnNotifications ||
    _vm.displayRegPathwayNotifications
      ? _c("div", { staticClass: "col-sm-12 col-xs-12 footer" }, [
          _c(
            "div",
            {
              staticClass:
                "col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-block emergo-white-button",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("closepopup")
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-block emergo-green-button",
                  attrs: { type: "button" },
                  on: { click: _vm.updatePreferences },
                },
                [_vm._v(" Save Changes ")]
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Registrations are added"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-xs-12 col-sm-6" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Registrations are edited"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Registrations are deleted"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Registrations status changes"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("label", { staticClass: "alert_text" }, [
        _vm._v("Registration expire soon"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "indicator-message-expires" }, [
      _vm._v(
        " ** As an In-country Representation client you will continue to receive in-app and email notifications on upcoming expirations for Emergo-managed records. Notifications will be turned off "
      ),
      _c("b", [_vm._v("only")]),
      _vm._v(" for records added directly by your organization. ** "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }